import { Form, Input, Modal } from "antd";
import DynamicButton from "components/DynamicButton";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fontSize } from "utils/CONSTANTS";
import { convertToRGBAString, renderSmile } from "utils/helperFunctions";
import { GoldenRatio } from "./GolderRatio";
import { orderByPosition } from "utils/helperFunctions";
import {
  closeMarkpage,
  fetchSendCollectedFeedback,
  nextPage,
  saveFeedback,
  setScroll,
} from "Redux/actions";

const commentInitial = {
  visible: false,
  mark: null,
};

const Header = React.memo(({ height, data, selectedLanguage, rate }) => {
  return (
    <div className="markpage_header" style={{ minHeight: height }}>
      <span
        className="markpage_header_smile"
        style={{
          color: convertToRGBAString(data.rate_icon_color),
        }}
      >
        {renderSmile(rate)}
      </span>
      <div
        className="markpage_header_title_wrapper"
        style={{
          fontSize: fontSize[data.title_size],
          color: convertToRGBAString(data.title_text_color),
          backgroundColor: convertToRGBAString(data.title_bg_color),
        }}
      >
        <p className="markpage_header_title_wrapper_text">
          {data.title[selectedLanguage]}
        </p>
      </div>
    </div>
  );
});

const Buttons = React.memo(
  ({
    data,
    selectedLanguage,
    handleClick,
    is_single,
    required,
    comment,
    generalSettings,
  }) => {
    // Buttons Attributes
    const buttonAttr = {
      cancel: {
        text: generalSettings.back_button_text,
        textColor: data.skip_button_text_color,
        backGroundColor: data.skip_button_bg_color,
      },
      submit: {
        text: generalSettings.submit_button_text,
        textColor: data.submit_button_text_color,
        backGroundColor: data.submit_button_bg_color,
      },
    };

    const generateButtons = () => {
      const buttons = [];
      Object.keys(buttonAttr).forEach((button, index) => {
        buttons.push(
          <DynamicButton
            key={index}
            className={"markpage_footer_button"}
            button={{
              enabled: true,
              title: buttonAttr[button].text[selectedLanguage],
              color: buttonAttr[button].textColor,
              backgroundColor: buttonAttr[button].backGroundColor,
            }}
            handleClick={() => handleClick(button)}
          />
        );
      });
      return buttons;
    };

    return <div className={`markpage_footer `}>{generateButtons()}</div>;
  }
);

const Mark = React.memo(
  ({ mark, isSelected, is_single, selectedLanguage, handleClick }) => {
    const markStyle = {
      true: {
        color: mark.selected_text_color,
        borderColor: mark.mark_selected_color,
        backGroudColor: mark.selected_bg_color,
      },
      false: {
        color: mark.text_color,
        borderColor: mark.mark_border_color,
        backGroudColor: mark.bg_color,
      },
    };
    return (
      <li
        className="markpage_main_mark"
        style={{
          color: convertToRGBAString(markStyle[isSelected].color),
          borderColor: convertToRGBAString(markStyle[isSelected].borderColor),
          backgroundColor: convertToRGBAString(
            markStyle[isSelected].backGroudColor
          ),
        }}
        onClick={() => handleClick("mark", mark)}
      >
        {/* {!is_single && (
          <span className="markpage_main_mark_icon">
            {isSelected ? (
              <IoMdCheckboxOutline size={16} />
            ) : (
              <MdOutlineCheckBoxOutlineBlank size={16} />
            )}
          </span>
        )} */}
        {mark.name[selectedLanguage]}
      </li>
    );
  }
);
const Comment = React.memo(
  ({ form, mark, selectedLanguage, generalSettings }) => {
    const { comment } = mark || {};
    const { error_messages } = generalSettings || {};

    return (
      <Form form={form}>
        <Form.Item
          name={"comment"}
          rules={[
            {
              required: comment.required,
              message: error_messages.required[selectedLanguage],
            },
            {
              min: comment.min_length,
              message: error_messages.too_short[selectedLanguage],
            },
            {
              max: comment.max_length,
              message: error_messages.too_long[selectedLanguage],
            },
          ]}
        >
          <Input.TextArea
            rows={6}
            autoFocus={true}
            placeholder={comment.placeholder}
            className="markpage_comment"
          />
        </Form.Item>
      </Form>
    );
  }
);

const Main = React.memo(
  ({
    height,
    selectedLanguage,
    data,
    selected,
    handleClick,
    is_single,
    comment,
    form,
    generalSettings,
  }) => {
    const { marks } = data || {};
    return comment.visible ? (
      <Comment
        {...{ form, selectedLanguage, mark: comment.mark, generalSettings }}
      />
    ) : (
      <ul className="markpage_main" style={{ maxHeight: height }}>
        {orderByPosition(marks).map((mark, index) => {
          const isSelected = selected.some(
            (selectedMark) => selectedMark.id === mark.id
          );
          return (
            <Mark
              key={index}
              {...{
                isSelected,
                selectedLanguage,
                handleClick,
                is_single,
                mark,
              }}
            />
          );
        })}
      </ul>
    );
  }
);

const Markpage = () => {
  //Dependencies
  const dispatch = useDispatch();
  const {
    markpage,
    selectedLanguage,
    feedbackArray,
    pageComponents,
    isFinal,
    widgetJSON: {
      data: { general_settings },
    },
  } = useSelector((state) => state);
  const { show, data, rate, serviceId } = markpage;
  const { is_single, required } = data || {};

  // Markpage Modal size
  const [isValid, setİsValid] = useState(true);
  const [selected, setSelected] = useState([]);
  const [comment, setComment] = useState(commentInitial);
  const [sizes, setSizes] = useState({
    height: 0,
    header: 0,
    main: 0,
  });

  // useForm
  const [form] = Form.useForm();

  const handleClick = useCallback(
    (type, data) => {
      const feedbackData = {
        serviceId,
        rate,
        markpage,
        marks: [],
      };

      switch (type) {
        case "cancel": {
          const { visible } = comment;
          if (visible && markpage.data.marks.length !== 1) {
            const foundCommentable = markpage.data.marks.find(
              (mark) => mark.comment.is_commentable
            );
            setSelected((prevSelected) => {
              let newSelected = [];
              prevSelected.forEach((selected) => {
                if (
                  !(
                    foundCommentable.id === selected.id &&
                    foundCommentable.comment.required
                  )
                ) {
                  newSelected.push({
                    ...selected,
                    comment: "",
                  });
                }
              });
              return newSelected;
            });
            setComment(commentInitial);
          } else {
            dispatch(closeMarkpage());
          }
          form.resetFields();
          break;
        }
        case "mark": {
          const {
            id,
            comment: { is_commentable },
          } = data;

          const mark = { id, comment: "" };
          setSelected((prevSelected) => {
            let newSelected = [...prevSelected];
            const selected = newSelected.some(
              (selectedMark) => selectedMark.id === id
            );
            if (selected) {
              newSelected = newSelected.filter(
                (selectedMark) => selectedMark.id !== id
              );
            } else if (is_single) {
              newSelected = [mark];
            } else {
              newSelected.push(mark);
            }

            if (is_commentable && !selected) {
              setComment({
                visible: true,
                mark: data,
              });
            }
            return newSelected;
          });
          break;
        }
        case "submit": {
          const { visible, mark } = comment;

          const feedbackSubmit = (feedbackData) => {
            dispatch(saveFeedback(feedbackData));
            if (
              pageComponents.length === 1 &&
              pageComponents[0].attrs?.service?.length === 1
            ) {
              if (isFinal) {
                dispatch(fetchSendCollectedFeedback());
              } else {
                dispatch(nextPage());
              }
            }
          };

          setSelected((selected) => {
            if (visible) {
              form.validateFields().then((data) => {
                feedbackData.marks = [
                  {
                    id: mark.id,
                    comment: data.comment ? data.comment : "",
                  },
                ];
                feedbackSubmit(feedbackData);
              });
            } else if (required && selected.length === 0) {
              setİsValid(false);
            } else {
              if (selected.length === 0) {
                feedbackData.markpage = null;
              } else {
                feedbackData.marks = selected;
              }
              feedbackSubmit(feedbackData);
            }
            return selected;
          });
          break;
        }
        default: {
          console.log("button click");
          break;
        }
      }
    },
    [
      rate,
      serviceId,
      is_single,
      required,
      markpage,
      comment,
      form,
      isFinal,
      pageComponents,
      dispatch,
    ]
  );

  useEffect(() => {
    const { A: height } = GoldenRatio({ height: window.innerHeight });
    const { A: main, B: header } = GoldenRatio({ height });
    setSizes({ height, header, main });
  }, []);

  useEffect(() => {
    dispatch(setScroll(!show))
  },[show])
  
  useEffect(() => {
    const { marks = [] } = data || {};
    if (
      marks.length === 1 &&
      marks[0].comment.is_commentable &&
      !comment.visible
    ) {
      setComment({
        mark: marks[0],
        visible: true,
      });
    }
  }, [data, comment]);

  useEffect(() => {
    if (feedbackArray) {
      const foundFeedback = feedbackArray.find(
        (feedback) => feedback.serviceId === serviceId && feedback.rate === rate
      );
      const { marks = [] } = foundFeedback || {};
      if (marks.length !== 0 && marks[0].comment !== "") {
        form.setFieldsValue({
          comment: marks[0].comment,
        });
        setComment({
          visible: true,
          mark: data.marks.find((mark) => mark.id === marks[0].id),
        });
      }
      setSelected(marks);
    }
  }, [feedbackArray, serviceId, rate, data, form]);

  useEffect(() => {
    if (!isValid && selected.length !== 0) setİsValid(true);
  }, [selected, isValid]);

  // Common props
  const props = {
    height: sizes.header,
    data,
    selectedLanguage,
    rate,
    is_single,
    required,
    generalSettings: general_settings,
  };
  return (
    <Modal
      className={`markpage ${!isValid && "markpage--required"}`}
      open={show}
      visible={show}
      closable={false}
      afterClose={() => {
        setİsValid(true);
        setSelected([]);
        setComment(commentInitial);
        form.resetFields();
      }}
      footer={
        <Buttons
          {...props}
          handleClick={handleClick}
          comment={comment.visible}
        />
      }
      centered
    >
      <Header {...props} />
      <Main
        {...{
          ...props,
          selected,
          handleClick,
          comment,
          setComment,
          form,
        }}
      />
    </Modal>
  );
};

export default Markpage;
